<igx-grid #gridFamilias [autoGenerate]="false" [width]="'100%'" [height]="'100%'" [locale]="localGrid"
  [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="activarBotones ? rowSelectionSingle : rowSelectionMultiple" [selectRowOnClick]="false" [sortingOptions]="sortingOptions"
  [rowEditable]="true" [primaryKey]="'IdFamilia'" (rowEditEnter)="rowEditEnter()" (rowEditExit)="rowEditExit()"
  (rowEditDone)="addUpdateFamilia($event)" (rowEdit)="validarFamilia($event)" (contextMenu)="menuContextual($event)" (window:click)="disableContextMenu()" (rowSelectionChanging)="handleRowSelection()"
  [igxGridState]="optionsGridLocal" (columnInit)="onColumnInit($event)" (keydown)="customKeydown($event)" [moving]="true" paste-handler-neodata (onDataProcessed)="datosPegadosDesdeExcel($event)">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general-moderno #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[0, 1, 2, 3, 6]" (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="Familia" header="{{ 'GRIDS.FAMILIA.COL_FAMILIA' | translate}}" [dataType]="'string'" width="140px" [sortable]="true" [resizable]="true">
    <ng-template igxHeader #familiaHeaderTemplate let-column>
      <div title="{{ 'GRIDS.FAMILIA.COL_FAMILIA' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #familiaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="Familia" [(ngModel)]="cell.editValue" uppercase [igxTextSelection]="true" [igxFocus]="true" type="text" maxlength="20" (keydown)="stopPropagationPegado($event)"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="DescripcionFamilia" header="{{ 'GRIDS.FAMILIA.COL_DESCRIPCION' | translate}}" [dataType]="'string'" width="220px" [sortable]="true" [resizable]="true" [hasSummary]="true" [summaries]="'filasSummary' | summaryPipeNeo">
    <ng-template igxCellEditor #descripcionFamiliaEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="DescripcionFamilia" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true" type="text" maxlength="40" (keydown)="stopPropagationPegado($event)"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <!--Acciones Editar, Agregar y Borrar-->
  @if (showActionStrip) {
    <igx-action-strip #actionstrip>
      <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab" style="margin-right: 5px" (buttonClick)="accionStripRowBtn(actionstrip.context, 1)">
        <igx-icon>add</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple style="margin-right: 5px" (buttonClick)='startEdit(actionstrip.context)'>
        <igx-icon>edit</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab" (buttonClick)="accionStripRowBtn(actionstrip.context, 2)">
        <igx-icon>delete</igx-icon>
      </button>
    </igx-action-strip>
  }
</igx-grid>
@if (verContextMenu) {
  <app-context-menu-generico [cellMenuContextual]="cellMenuContextaul" [menusOpciones]="menus" [lengthMenu]="lengthMenu" [size]="sizeMenu" [subMenusOpciones]="subMenusOpciones"
                             (accionSeleccionada)="accionSeleccionada($event)" [x]="contextmenuX" [y]="contextmenuY" />
}
